export var DISCOVER = 'discover';
export var SEARCH = 'search';